import React from 'react';

const HeartIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21.9304L2.2 11.8384C1.3405 10.9953 0.771813 9.90051 0.57637 8.71257C0.380926 7.52462 0.568885 6.3053 1.113 5.23136C1.53221 4.41761 2.13687 3.71382 2.87818 3.1768C3.61949 2.63978 4.47667 2.28457 5.38054 2.13985C6.28441 1.99512 7.20965 2.06494 8.08157 2.34365C8.95349 2.62237 9.74767 3.10218 10.4 3.74436L12 5.20336L13.6 3.74436C14.2524 3.10239 15.0466 2.62275 15.9185 2.34416C16.7904 2.06557 17.7155 1.99581 18.6193 2.14052C19.5231 2.28524 20.3803 2.64037 21.1216 3.17726C21.8629 3.71415 22.4676 4.41777 22.887 5.23136C23.4308 6.30538 23.6186 7.52462 23.4232 8.71249C23.2277 9.90036 22.6592 10.9952 21.8 11.8384L12 21.9304Z"
      stroke="#4B4B4B"
    />
  </svg>
);

export default HeartIcon;
